module.exports = {
  "country": "ES",
  "artist": "Edurne",
  "song": "Amanecer",
  "year": "2015",
  "place": "21",
  "spotify": "2zHDsCjQGp7XqsqrrNR9t9"
};